import $ from "jquery"

import ASwapDispatcher from "./ASwapDispatcher";
import Events from "./Events";

class ASwap {
  /**
  * @constructor
  **/
  constructor() {
    this.controllers = []; // tablica {id, controller}
    this.params = {
      animationTimeHide: 800, // hide animation time
      animationTimeShow: 800, // show animation time
      formsEnabled: true, // use aswap on forms
      formsSelector: 'form[method="get"]', // aswap forms selector
      historyEnabled: true, // use history push state
      historyFallback: true, // fallback of browser dosn't support history push state
      cacheOn: true, // use Aswap Cache?
      noCacheClassName: 'no-as-cache', // links with this class don't use ajax cache
      noScrollClassName: 'no-as-scroll', // links with this class don't scroll window back up
      noSwapClassName: 'no-as', // links with this class or target=_blank don't use ajax swap
      oldschoolBrowserFallback: true, // IE11 or lower is not supported
      preloadOnHover: false, // preload links on hover
      refreshOnSameUrl: true, // refresh window if same URL is requested
      routes: {},
      swapSelector: '#stage', // swap wrapper selector
      defaultDocumentScrollBehavior: 'smooth',
      trace: () => {}, // a function to trace progress in console
    }
    // public events
    this.events = {
      onInited: () => {}, 
      onRequestUrl: () => {},
      onRequestLoad: () => {},
      onRequestLoaded: () => {},
      onViewHide: () => {},
      onViewHidden: () => {},
      onViewSwapStart: () => {},
      onViewSwapComplete: () => {},
      onViewShow: () => {},
      onViewShown: () => {},
    }
  }
  

  /**
   * INIT ASwap
   * @param {*} params 
   */
  init(params = {}, events = {}) {
    for ( let param in params ) {
      if ( this.params.hasOwnProperty(param) ) {
        this.params[param] = params[param]
      }
    }
    for ( let event in events ) {
      if ( this.events.hasOwnProperty(event) ) {
        this.events[event] = events[event]
      }
    }
    this.dispatcher = new ASwapDispatcher(this.params);

    this.dispatcher.on(Events.NAV_REQUEST_URL, this.onRequestUrl.bind(this));
    this.dispatcher.on(Events.NAV_REQUEST_LOAD, this.onRequestLoad.bind(this));
    this.dispatcher.on(Events.NAV_REQUEST_LOADED, this.onRequestLoaded.bind(this));
    this.dispatcher.on(Events.NAV_VIEW_HIDE, this.onViewHide.bind(this));
    this.dispatcher.on(Events.NAV_VIEW_HIDDEN, this.onViewHidden.bind(this));
    this.dispatcher.on(Events.NAV_SWAP_START, this.onViewSwapStart.bind(this));
    this.dispatcher.on(Events.NAV_SWAP_COMPLETE, this.onViewSwapComplete.bind(this));
    this.dispatcher.on(Events.NAV_VIEW_SHOW, this.onViewShow.bind(this));
    this.dispatcher.on(Events.NAV_VIEW_SHOWN, this.onViewShown.bind(this));

    this.dispatcher.init();
    // on inited
    this.events.onInited();
  }

  /**
  * go to URL
  * @param {String} url
  * @param {Boolean} noHistory - if the pushState should be skipped (default false)
  **/
  openURL(url, noHistory = false, useCache = true) {
    if (this.dispatcher) {
      this.dispatcher.openURL(url, noHistory, useCache)
    }
  }

  onRequestUrl(e) {
    document.documentElement.classList.add('as-in-progress')
    this.getActiveControlles().forEach( (c, index)=> {
      c.onRequestUrl(e);
    });
    this.events.onRequestUrl()
  }
  onRequestLoad(e) {
    document.documentElement.classList.add('js');
    document.documentElement.classList.add('as-request-loading');
    this.getActiveControlles().forEach( (c, index)=> {
      c.onRequestLoad(e);
    })
    this.events.onRequestLoad()
  }
  onRequestLoaded(e) {
    this.getControllersFromContainer(e.target.$freshContent).forEach( (c, index)=> {
      c.onRequestLoaded(e);
    });
    document.documentElement.classList.remove("as-request-loading");
    this.events.onRequestLoaded()
  }
  onViewHide(e) {
    document.documentElement.classList.add('as-hide');
    this.getActiveControlles().forEach( (c, index)=> {
      // if view is not present in fresh content then call controller hide
      if (!c.getViewContainer(e.target.$freshContent).length) {
        c.onViewHide(e);
      }
    });
    this.events.onViewHide()
  }
  onViewHidden(e) {
    document.documentElement.classList.remove('as-hide');
    this.getActiveControlles().forEach( (c, index)=> {
      // if view is not present in fresh content then call controller hidden
      if (!c.getViewContainer(e.target.$freshContent).length) {
        c.onViewHidden(e);
      }
    });
    this.events.onViewHidden()
  }
  onViewSwapStart(e) {
    this.getControllersFromContainer(e.target.$freshContent).forEach( (c, index)=> {
      c.onViewSwapStart(e);
    });
    this.events.onViewSwapStart()
  }
  onViewSwapComplete(e) {
    this.getControllersFromContainer(e.target.$freshContent).forEach( (c, index)=> {
      c.onViewSwapComplete(e);
    });
    this.events.onViewSwapComplete()
  }
  onViewShow(e) {
    document.documentElement.classList.add('as-show');
    this.getControllersFromContainer(e.target.$freshContent).forEach( (c, index)=> {
      c.onViewShow(e);
    });
    this.events.onViewShow()
  }
  onViewShown(e) {
    document.documentElement.classList.add('as-show');
    this.getControllersFromContainer(e.target.$freshContent).forEach( (c, index)=> {
      c.onViewShown(e);
    });
    document.documentElement.classList.remove('as-in-progress');
    this.events.onViewShown()
  }


  /**
  * get an array of all active controllers
  * @returns {Array}
  **/
  getActiveControlles() {
    let arr = [];
    this.controllers.forEach( (obj, index)=> {
      if (obj.controller.active) {
        arr.push(obj.controller);
      }
    });
    return arr;
  }
  /**
  * get controllers from container based on view's included in the container
  * @param {jQuery} $container
  * @returns {Array}
  **/
  getControllersFromContainer($container) {
    let arr = [];
    $container.find("*[data-as-view]").each( (index, el)=> {
      let name = $(el).data("as-view");
      let id = $(el).data("as-id");
      if (!id) {
        id = name;
      }
      let c = this.getController(name, id);
      if (c) {
        arr.push(c);
      }
    });
    return arr;
  }
  /**
  * get controller (check store if not found create new controller)
  * @param {String} name
  * @param {Int|String} id - unique ID
  * @returns {EventDispatcher}
  **/
  getController(name, id) {
    let c = this.getStoredController(id);
    if (!c) {
      c = this.createController(name, id);
      if (c) {
        this.storeController(id, c);
      }
    }
    return c;
  }

  /**
  * create controller
  * @param {String} name - controller type name
  * @param {Int|String} id - unique ID
  * @returns {EventDispatcher}
  **/
  createController(name, id) {
    let c = false;
    const routes = this.params.routes
    if (routes[name]) {
      if (routes[name].controller) {
        c = new routes[name]["controller"](id);
        c.name = name;
        if (routes[name].view) {
          c.setView( new routes[name]["view"](id) );
        }
        this.params.trace("controller created", name, id, c);
      }
    }
    return c;
  }
  /**
  * store controller
  * @param {Int|String} id - unique controller ID
  * @param {EventDispatcher} controller
  **/
  storeController(id, controller) {
    this.controllers.push({id, controller})
  }
  /**
  * get controller from store
  * @param {Int|String} id
  * @returns {EventDispatcher}
  **/
  getStoredController(id) {
    let controller = false;
    this.controllers.forEach( (r, index)=> {
      if (r.id == id) {
        controller = r.controller;
      }
    });
    return controller;
  }


}
const aswapInstance = new ASwap();
export default aswapInstance;
